import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  REGION_SWITCH_EVENT,
  clearPendingRegionSwitch,
  getPendingRegionSwitch,
} from '@common/src/config/regions'
import BootScreen from './bootScreen'

/**
 * Full-screen loading screen over the app shell while the signed-in user and menu load, so the empty shell
 * (blank page, sidebar spinner) never shows. Pulse has no region picker: a sub-admin of another region is moved
 * to it at login, which reloads the app; the screen then shows "Switching to <region>…" until that load is done.
 * Before the shell mounts, index.html and BootScreen (auth start-up) show the same screen.
 */
const PageLoader = () => {
  const loading = useSelector((state) => state.auth?.loading)
  const [switchingTo, setSwitchingTo] = useState(getPendingRegionSwitch)

  useEffect(() => {
    const onSwitch = (event) => setSwitchingTo(event.detail?.label || null)
    window.addEventListener(REGION_SWITCH_EVENT, onSwitch)
    return () => window.removeEventListener(REGION_SWITCH_EVENT, onSwitch)
  }, [])

  // The first load after a switch is done: drop the "Switching to…" message. The login switch starts while
  // loading is still true, so the screen stays until the reload.
  useEffect(() => {
    if (loading) return
    clearPendingRegionSwitch()
    setSwitchingTo(null)
  }, [loading])

  if (!loading && !switchingTo) return null

  return <BootScreen message={switchingTo ? `Switching to ${switchingTo}…` : 'Loading…'} />
}

export default PageLoader
